import PropTypes from 'prop-types';

import Text from '@zenbusiness/zui/Text';

import * as Styled from './EntityMenuItem.style';
import { MenuItem } from '../MenuItem';

function EntityMenuItem({ entity, onClick }) {
  return (
    <MenuItem
      onClick={onClick}
      variant={entity.hasNameReservation ? 'reserved' : ''}
    >
      <Styled.Link
        aria-label={entity.name}
        clickstreamProps={entity.eventProps}
        role="menuitem"
        to={entity.path}
      >
        <Styled.EntityInfo>
          <Text truncate>{entity.name}</Text>
          {entity.domesticJurisdiction && (
            <Styled.Jurisdiction>
              {entity.domesticJurisdiction}
            </Styled.Jurisdiction>
          )}
        </Styled.EntityInfo>
        {entity.hasNameReservation && (
          <Styled.Pill>
            Reserved
          </Styled.Pill>
        )}
      </Styled.Link>
    </MenuItem>
  );
}

EntityMenuItem.propTypes = {
  entity: PropTypes.shape({
    hasNameReservation: PropTypes.bool.isRequired,
    domesticJurisdiction: PropTypes.string,
    eventProps: PropTypes.shape({
      dynamicProperties: PropTypes.shape({
        navIndex: PropTypes.number,
        navLevel: PropTypes.number
      }),
      elementName: PropTypes.string,
      appSection: PropTypes.string
    }).isRequired,
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  }).isRequired,
  onClick: PropTypes.func.isRequired
};

export default EntityMenuItem;
